import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../../models/https';
import { activeJobApplicationsActions } from '../../../redux/slices/activeJobApplicationsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

interface JobApplicationsFilter {
  page?: string;
  perPage?: string;
}

const useGetActiveJobApplications = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetActiveJobApplicationsError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    console.error(
      err?.message ??
        'Something went wrong while fetching active job applications'
    );
  };

  const getActiveJobApplications = (filter?: JobApplicationsFilter) => {
    // Extract pagination values from the filter or use defaults
    const page = parseInt(filter?.page ?? '1', 10);
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    // Compute offset (0-indexed) from the page number (which is 1-indexed)
    const offset = page - 1;

    // Build the URL using the offset instead of the page parameter.
    const urlPath = `jobs-service/applications/active?offset=${offset}&perPage=${perPage}`;

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetActiveJobApplicationsSuccess = (response: PaginatedResponse) => {
      const {
        numberOfElements,
        totalElements,
        first,
        last,
        totalPages,
        content,
      } = response;

      dispatch(
        activeJobApplicationsActions.activeJobApplications({
          numberOfElements,
          totalElements,
          first,
          last,
          totalPages,
          jobData: Array.isArray(content) ? content : [],
        })
      );
    };

    return request(
      url,
      onGetActiveJobApplicationsSuccess,
      setLoading,
      onGetActiveJobApplicationsError
    );
  };

  return { getActiveJobApplications, loading };
};

export default useGetActiveJobApplications;
